const yaCounter = window.yaCounter25586834;

const yaClientId = () => {
  const match = document.cookie.match('(?:^|;)\\s*_ym_uid=([^;]*)');
  return match ? decodeURIComponent(match[1]) : null;
};

export { yaClientId, yaCounter };
